module.exports = __webpack_public_path__ + "img/eye.3e56b422.svg";